import axios from "axios";
import { eraseCookie } from "../redux-config/hooks";
import Swal from "sweetalert2";

export class Api {
    public constructor(input: {
        path: string;
        method: "get" | "post" | "delete" | "put" | "patch";
        body?: any;
        header?: any;
        params?: any;
        secondUrl?: any;
        ignore404Redirect?: boolean;
        reject422?: boolean;
    }) {
        this.path = input.path;
        this.secondUrl = input.secondUrl;
        this.method = input.method;
        this.body = input.body;
        this.header = input.header;
        this.params = input.params;
        this.ignore404Redirect = Boolean(input.ignore404Redirect);
        this.reject422 = Boolean(input.reject422);
    }
    private _uri: string = String(process.env.REACT_APP_API_REST_URL);
    private _path: string = "";
    private _params: string = "";
    private _method: "get" | "post" | "delete" | "put" | "patch" = "get";
    private _body?: any;
    private _header?: any;
    private _secondUrl?: any;
    private _ignore404Redirect: boolean = false;
    private _reject422: boolean = false;

    public get secondUrl() {
        return this._secondUrl;
    }
    public set secondUrl(secondUrl: any) {
        this._secondUrl = secondUrl;
    }

    public get url(): string {
        return this._uri;
    }
    public set path(path: string) {
        this._path = path;
    }
    public get path(): string {
        return this._path;
    }
    public set params(params: string) {
        this._params = params;
    }
    public get params(): string {
        return this._params;
    }

    public set method(method: "get" | "post" | "delete" | "put" | "patch") {
        this._method = method;
    }
    public get method() {
        return this._method;
    }

    public set body(body: any) {
        this._body = body;
    }
    public get body() {
        return this._body;
    }
    public get header() {
        return this._header;
    }
    public set header(header: any) {
        this._header = header;
    }
    public get ignore404Redirect() {
        return this._ignore404Redirect;
    }
    public set ignore404Redirect(ignore404Redirect: boolean) {
        this._ignore404Redirect = ignore404Redirect;
    }
    public get reject422() {
        return this._reject422;
    }
    public set reject422(reject422: boolean) {
        this._reject422 = reject422;
    }

    async call() {
        return new Promise((resolve, reject) => {
            axios({
                method: this.method,
                url:
                    this.secondUrl && this.secondUrl.length > 0
                        ? this.secondUrl
                        : this.url + this.path,
                headers: this.header,
                data: this.body,
                params: this.params,
            })
                .then((data) => {
                    resolve(data.data);
                })
                .catch((data) => {
                    const code = data?.response?.status;

                    if (code == 404) {
                        if (this.ignore404Redirect) {
                            reject(data.response);
                            return;
                        }
                        window.location.replace("/404");
                    } else if (code === 401) {
                        eraseCookie("user");
                        localStorage.clear();
                        window.location.replace("/login");
                    } else if (code === 429) {
                        window.location.replace("/429");
                    } else if (code === 422) {
                        if (this.reject422) {
                            reject(data.response);
                            return;
                        }
                        Swal.fire({
                            icon: "error",
                            text: data?.response?.data?.message,
                        });
                    } else {
                        reject(data.response);
                    }
                });
        });
    }
}
